import React, { useState } from 'react'
import {
  inicioService,
  almacenadoService,
  capaControladorService,
  pruebasService,
  postmanService,
  frontService,
  ensamblarFront,
  ensamblarBack,
} from 'src/services/virgilioService'
import './virgilio.css'

const VirgilioContainer = () => {
  const capas = {
    flujo: 'FLUJO',
    controlador: 'CONTROLADOR',
    db: 'DB',
    io: 'IO',
  }

  const frontCapas = {
    componente: 'COMPONENTE',
    estilo: 'ESTILO',
    servicio: 'SERVICIO',
    enrutado: 'ENRUTADO',
  }

  const [nombreEntidad, setNombreEntidad] = useState('')
  const [archivo, setArchivo] = useState(null)

  const [loading, setLoading] = useState(false)
  const [completed, setCompleted] = useState(false)
  const [errorr, setErrorr] = useState(false)

  const [loadingAlmacenado, setLoadingAlmacenado] = useState(false)
  const [completedAlmacenado, setCompletedAlmacenado] = useState(false)
  const [errorrAlmacenado, setErrorrAlmacenado] = useState(false)

  const [loadingCapaControlador, setLoadingCapaControlador] = useState(false)
  const [completedCapaControlador, setCompletedCapaControlador] = useState(
    false,
  )
  const [errorrCapaControlador, setErrorrCapaControlador] = useState(false)

  const [loadingPruebas, setLoadingPruebas] = useState(false)
  const [completedPruebas, setCompletedPruebas] = useState(false)
  const [errorrPruebas, setErrorrPruebas] = useState(false)

  const [loadingPostman, setLoadingPostman] = useState(false)
  const [completedPostman, setCompletedPostman] = useState(false)
  const [errorrPostman, setErrorrPostman] = useState(false)

  const [loadingFront, setLoadingFront] = useState(false)
  const [completedFront, setCompletedFront] = useState(false)
  const [errorrFront, setErrorrFront] = useState(false)

  const [loadingEnsamblarBack, setLoadingEnsamblarBack] = useState(false)
  const [completedEnsamblarBack, setCompletedEnsamblarBack] = useState(false)
  const [errorrEnsamblarBack, setErrorrEnsamblarBack] = useState(false)

  const [loadingEnsamblarFront, setLoadingEnsamblarFront] = useState(false)
  const [completedEnsamblarFront, setCompletedEnsamblarFront] = useState(false)
  const [errorrEnsamblarFront, setErrorrEnsamblarFront] = useState(false)

  const [idSave, setIdSave] = useState('')

  const handleEnsamblarFront = async (ids) => {
    setCompletedEnsamblarBack(true)
    setLoadingEnsamblarFront(true)
    try {
      const response = await ensamblarFront(ids)
      if (response.status === 200) {
        alert('proceso terminado')
        setCompletedEnsamblarFront(true)
      } else {
        setErrorrEnsamblarFront(true)
      }
    } catch (error) {
      console.log('Error al enviar datos:', error)
      setErrorrEnsamblarFront(true)
      setCompletedEnsamblarFront(false)
    }
  }

  const handleEnsamblarBack = async (ids) => {
    setCompletedFront(true)
    setLoadingEnsamblarBack(true)

    try {
      const response = await ensamblarBack(ids)
      if (response.status === 200) {
        handleEnsamblarFront(ids)
      } else {
        setErrorrEnsamblarBack(true)
      }
    } catch (error) {
      console.log('Error al enviar datos:', error)
      setErrorrEnsamblarBack(true)
      setCompletedEnsamblarBack(false)
    }
  }

  const handleFront = async (ids) => {
    setCompletedPostman(true)
    setLoadingFront(true)
    try {
      const response = await frontService(ids, frontCapas.componente)

      if (response.status === 200) {
        try {
          const response2 = await frontService(ids, frontCapas.estilo)

          if (response2.status === 200) {
            try {
              const response3 = await frontService(ids, frontCapas.servicio)

              if (response3.status === 200) {
                try {
                  const response4 = await frontService(ids, frontCapas.enrutado)
                  if (response4.status === 200) {
                    handleEnsamblarBack(ids)
                  }
                } catch (error) {
                  console.log('Error al enviar datos:', error)
                  setErrorrFront(true)
                  setCompletedFront(false)
                }
              }
            } catch (error) {
              console.log('Error al enviar datos:', error)
              setErrorrFront(true)
              setCompletedFront(false)
            }
          }
        } catch (error) {
          console.log('Error al enviar datos:', error)
          setErrorrFront(true)
          setCompletedFront(false)
        }
      }
    } catch (error) {
      console.log('Error al enviar datos:', error)
      setErrorrFront(true)
      setCompletedFront(false)
    }
  }

  const handlePostman = async (ids) => {
    setCompletedPruebas(true)
    setLoadingPostman(true)

    try {
      const response = await postmanService(ids)
      if (response.status === 200) {
        handleFront(ids)
      } else {
        setErrorrPostman(true)
      }
    } catch (error) {
      console.log('Error al enviar datos:', error)
      setErrorrPostman(true)
      setCompletedPostman(false)
    }
  }

  const handleCapaPruebas = async (ids) => {
    setCompletedCapaControlador(true)
    setLoadingPruebas(true)
    try {
      const response = await pruebasService(ids, capas.controlador)

      if (response.status === 200) {
        try {
          const response2 = await pruebasService(ids, capas.flujo)

          if (response2.status === 200) {
            try {
              const response3 = await pruebasService(ids, capas.db)

              if (response3.status === 200) {
                try {
                  const response4 = await pruebasService(ids, capas.io)

                  if (response4.status === 200) {
                    handlePostman(ids)
                  }
                } catch (error) {
                  console.log('Error al enviar datos:', error)
                  setErrorrPruebas(true)
                  setCompletedPruebas(false)
                }
              }
            } catch (error) {
              console.log('Error al enviar datos:', error)
              setErrorrPruebas(true)
              setCompletedPruebas(false)
            }
          }
        } catch (error) {
          console.log('Error al enviar datos:', error)
          setErrorrPruebas(true)
          setCompletedPruebas(false)
        }
      }
    } catch (error) {
      console.log('Error al enviar datos:', error)
      setErrorrPruebas(true)
      setCompletedPruebas(false)
    }
  }

  const handleCapaControlador = async (ids) => {
    setCompletedAlmacenado(true)
    setLoadingCapaControlador(true)
    try {
      const response = await capaControladorService(ids, capas.controlador)

      if (response.status === 200) {
        try {
          const response2 = await capaControladorService(ids, capas.flujo)

          if (response2.status === 200) {
            try {
              const response3 = await capaControladorService(ids, capas.db)

              if (response3.status === 200) {
                try {
                  const response4 = await capaControladorService(ids, capas.io)

                  if (response4.status === 200) {
                    handleCapaPruebas(ids)
                  }
                } catch (error) {
                  console.log('Error al enviar datos:', error)
                  setErrorrCapaControlador(true)
                  setCompletedCapaControlador(false)
                }
              }
            } catch (error) {
              console.log('Error al enviar datos:', error)
              setErrorrCapaControlador(true)
              setCompletedCapaControlador(false)
            }
          }
        } catch (error) {
          console.log('Error al enviar datos:', error)
          setErrorrCapaControlador(true)
          setCompletedCapaControlador(false)
        }
      }
    } catch (error) {
      console.log('Error al enviar datos:', error)
      setErrorrCapaControlador(true)
      setCompletedCapaControlador(false)
    }
  }

  const handleAlmacenado = async (ids) => {
    setCompleted(true)
    setLoadingAlmacenado(true)
    try {
      console.log(ids, 'id')
      if (ids) {
        const response = await almacenadoService(ids)

        if (response.status === 200) {
          handleCapaControlador(ids)
        }
      }
    } catch (error) {
      console.log('Error al enviar datos:', error)
      setErrorrAlmacenado(true)
      setCompletedAlmacenado(false)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErrorr(false)
    setCompleted(false)
    setLoading(true) // Reinicia el estado de error antes de cada solicitud
    const formData = new FormData()
    formData.append('nombre_entidad', nombreEntidad)
    formData.append('archivo', archivo)

    try {
      const response = await inicioService(formData)
      const ids = response.data.id
      setIdSave(ids)
      console.log(response.data.id)
      handleAlmacenado(ids)
    } catch (error) {
      console.error('Error al enviar datos:', errorr)
      setErrorr(true) // Se captura el error y se actualiza el estado
      setCompleted(false)
    }
    setLoading(false)
  }

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0])
  }

  return (
    <div className="principal-container_virgilio">
      <div className="container-left_virgilio">
        <div className="form-container_virgilio">
          <form className="form_virgilio" onSubmit={handleSubmit}>
            <input
              type="text"
              className="input_virgilio"
              value={nombreEntidad}
              onChange={(e) => setNombreEntidad(e.target.value)}
              placeholder="Nombre de la entidad"
            />
            <input
              type="file"
              onChange={handleFileChange}
              className="input_virgilio"
            />
            <button className="button_virgilio" type="submit">
              Empezar
            </button>
          </form>
        </div>

        <div className="process-container_virgilio">
          {(loading || completed || errorr) && (
            <>
              <div
                className={`loading-bar  loading-fast ${
                  completed ? 'completed' : ''
                } ${errorr ? 'error' : ''}`}
              >
                <p>Iniciando el proceso</p>
              </div>
              {errorr && (
                <p
                  onClick={() => {
                    handleInicio()
                  }}
                >
                  Intentar de nuevo
                </p>
              )}
            </>
          )}

          {(loadingAlmacenado || completedAlmacenado || errorrAlmacenado) && (
            <>
              <div
                className={`loading-bar  loading-fast ${
                  completedAlmacenado ? 'completed' : ''
                } ${errorrAlmacenado ? 'error' : ''}`}
              >
                <p>Realizando proceso de almacenado </p>
              </div>
              {errorrAlmacenado && (
                <p
                  onClick={() => {
                    handleAlmacenado(idSave)
                  }}
                >
                  Intentar de nuevo
                </p>
              )}
            </>
          )}

          {(loadingCapaControlador ||
            completedCapaControlador ||
            errorrCapaControlador) && (
            <>
              <div
                className={`loading-bar  loading-slow ${
                  completedCapaControlador ? 'completed' : ''
                } ${errorrCapaControlador ? 'error' : ''}`}
              >
                <p>Realizando capas del backend </p>
              </div>
              {errorrCapaControlador && (
                <p
                  onClick={() => {
                    handleCapaControlador(idSave)
                  }}
                >
                  Intentar de nuevo
                </p>
              )}
            </>
          )}

          {(loadingPruebas || completedPruebas || errorrPruebas) && (
            <>
              <div
                className={`loading-bar  loading-slow ${
                  completedPruebas ? 'completed' : ''
                } ${errorrPruebas ? 'error' : ''}`}
              >
                <p>Realizando pruebas unitarias</p>
                {errorrPruebas && (
                  <p
                    onClick={() => {
                      handleCapaPruebas(idSave)
                    }}
                  >
                    Intentar de nuevo
                  </p>
                )}
              </div>
            </>
          )}

          {(loadingPostman || completedPostman || errorrPostman) && (
            <>
              <div
                className={`loading-bar  loading-fast ${
                  completedPostman ? 'completed' : ''
                } ${errorrPostman ? 'error' : ''}`}
              >
                <p>Realizando colección de Postman</p>
              </div>
              {errorrPostman && (
                <p
                  onClick={() => {
                    handlePostman(idSave)
                  }}
                >
                  Intentar de nuevo
                </p>
              )}
            </>
          )}

          {(loadingFront || completedFront || errorrFront) && (
            <>
              <div
                className={`loading-bar  loading-slow ${
                  completedFront ? 'completed' : ''
                } ${errorrFront ? 'error' : ''}`}
              >
                <p>Realizando capas del Front End</p>
              </div>
              {errorrFront && (
                <p
                  onClick={() => {
                    handleFront(idSave)
                  }}
                >
                  Intentar de nuevo
                </p>
              )}
            </>
          )}

          {(loadingEnsamblarBack ||
            completedEnsamblarBack ||
            errorrEnsamblarBack) && (
            <>
              <div
                className={`loading-bar  loading-fast ${
                  completedEnsamblarBack ? 'completed' : ''
                } ${errorrEnsamblarBack ? 'error' : ''}`}
              >
                <p>Ensamblando backend</p>
              </div>
              {errorrEnsamblarBack && (
                <p
                  onClick={() => {
                    handleEnsamblarBack(idSave)
                  }}
                >
                  Intentar de nuevo
                </p>
              )}
            </>
          )}

          {(loadingEnsamblarFront ||
            completedEnsamblarFront ||
            errorrEnsamblarFront) && (
            <>
              <div
                className={`loading-bar  loading-fast ${
                  completedEnsamblarFront ? 'completed' : ''
                } ${errorrEnsamblarFront ? 'error' : ''}`}
              >
                <p>Ensamblando Frontend</p>
              </div>
              {errorrEnsamblarFront && (
                <p
                  onClick={() => {
                    handleEnsamblarFront(idSave)
                  }}
                >
                  Intentar de nuevo
                </p>
              )}
            </>
          )}

          {completedEnsamblarFront && (
            <>
              <p>Proceso terminado da click </p>
              <a
                target="blank"
                href={`https://virgiliofront.appengine.lucia.com.co/form-${nombreEntidad}`}
              >
                aqui
              </a>
            </>
          )}
        </div>
      </div>
      {loading ||
      loadingAlmacenado ||
      loadingCapaControlador ||
      loadingEnsamblarBack ||
      loadingEnsamblarFront ||
      loadingFront ||
      loadingPostman ||
      loadingPruebas ? (
        <img
          className="virglio-img"
          src=" 
          https://res.cloudinary.com/davidhuertas26/image/upload/v1715181226/auteco/virgilio/tw5b6qk1a4jel0wnerpz.png
      "
          alt=""
        />
      ) : errorr ||
        errorrAlmacenado ||
        errorrCapaControlador ||
        errorrEnsamblarBack ||
        errorrEnsamblarFront ||
        errorrFront ||
        errorrPostman ||
        errorrPruebas ? (
        <img
          className="virglio-img"
          src=" 
          https://res.cloudinary.com/davidhuertas26/image/upload/v1715181226/auteco/virgilio/zhyionwfiunv7aoxutoo.png
     "
          alt=""
        />
      ) : (
        <img
          className="virglio-img"
          src=" 
     https://res.cloudinary.com/davidhuertas26/image/upload/v1715181226/auteco/virgilio/cqoffpujfmh4123mwya7.png
     "
          alt=""
        />
      )}
    </div>
  )
}

export default VirgilioContainer
